import React from 'react'
const DogNumber = ctx => {
  return <span className={`number num${ctx.number} color-${ctx.color}`}>
    {ctx.number}
    <style jsx>{`
       .number {
        border:solid 1px #888;
        color: white;
        margin-right: 0;
      }
       .color-orange {
         background-color: #fd8000;
       }
       .color-red {
        background-color: red;
      }
       .color-bw {
        background: repeating-linear-gradient(0deg, black, white 9px)
      }
       .color-white {
        color: black;
      }
       .color-blue {
        background-color: #3779bb;
      }
       .color-yellow {
        background-color: #f4d419;
        color: black;
      }
       .color-green {
        background-color: #54a846;
        color: red;
      }
       .color-black {
        background-color: black;
        color: #f4d419;
      }
       .color-pink {
        background-color: #df4097;
        color: black;
      }
       .color-celtic {
        background: repeating-linear-gradient(45deg, #58a749, white 9px)
      }
       .color-tricolor {
        background: linear-gradient(90deg,red 33%,white 34%, white 66%,blue 67%, blue 100%);
        color: black;
      }
      `}</style>
    </span>
}

export default DogNumber
